import { useQuery } from "@tanstack/react-query";
import { getMyCompanyAffiliation } from "@/app/actions/affiliation/company/action";
import { QueryKey } from "@/app/vars/QueryKeys";

export function useFetchCompanyAffiliation(options: { enabled?: boolean } = {}) {
  const { enabled = true } = options;

  return useQuery({
    queryKey: [QueryKey.COMPANY_AFFILIATION],
    queryFn: getMyCompanyAffiliation,
    enabled,
    staleTime: Infinity,
  });
}
